import { render, staticRenderFns } from "./AppBarThemeSwitcher.vue?vue&type=template&id=35193d05&"
import script from "./AppBarThemeSwitcher.vue?vue&type=script&lang=js&"
export * from "./AppBarThemeSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports